module.exports = __webpack_public_path__ + "img/image_header.d59cf37b.png";